import { type AiActor } from '@databases/model/field';

export const AI_ACTORS = ['ai', 'user'] as const satisfies readonly AiActor[];

export const isAiActor = (value: unknown): value is AiActor =>
  typeof value === 'string' && AI_ACTORS.includes(value as AiActor);
